import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';
import { Input } from '@api/Inputs/Input';
import { UserType } from '@api/Users/User';

export interface DistributionCenterInventoryHistory {
    id?: string;
    distributionCenterId: string;
    inputs: {
        input: Input;
        quantity: number;
    }[];
    userData: UserType;
    date?: any;
    movementType: 'input' | 'output';
}

export const DISTRIBUTION_CENTER_INVENTORY_HISTORY_COLLECTION = 'distribution-center-inventory-history';
export const distributionCenterInventoryHistoryRef = collection(
    firestore,
    DISTRIBUTION_CENTER_INVENTORY_HISTORY_COLLECTION
);
